import { backend, localApi } from './definitions.js';
import { isDebugBuild } from './shared.js';

let runtimeParams = {};

export function setRendererParams(rendererParams) {
  runtimeParams = rendererParams;
}

export function storeBackend(backend) {
  localStorage.setItem('tokenized-backend', backend);
}

export function storeApiUrl(apiUrl) {
  localStorage.setItem('tokenized-api', apiUrl);
}

export function storeHandleDomain(handleDomain) {
  localStorage.setItem('tokenized-handle-domain', handleDomain);
}

export function getTokenizedBackend() {
  return '';
}

export function getApiUrl() {
  return '';
}

export function getSSEUrl() {
  return '';
}

export function getHandleDomain() {
  return localStorage.getItem('tokenized-handle-domain');
}
